import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';

const ProjectCard = ({ project, onViewDetails }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      whileHover={{ y: -8 }}
      onHoverStart={() => setIsHovered(true)}
      onHoverEnd={() => setIsHovered(false)}
      className="bg-card rounded-xl overflow-hidden border border-border shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer"
      onClick={() => onViewDetails(project)}
    >
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={project?.thumbnail}
          alt={project?.thumbnailAlt}
          className="w-full h-full object-cover transition-transform duration-500"
          style={{ transform: isHovered ? 'scale(1.1)' : 'scale(1)' }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background/90 to-transparent opacity-0 hover:opacity-100 transition-opacity duration-300 flex items-end p-4 md:p-6">
          <motion.div
            initial={{ y: 20, opacity: 0 }}
            animate={{ y: isHovered ? 0 : 20, opacity: isHovered ? 1 : 0 }}
            transition={{ duration: 0.3 }}
            className="flex items-center gap-2 text-primary font-medium"
          >
            <span>View Details</span>
            <Icon name="ArrowRight" size={20} color="var(--color-primary)" />
          </motion.div>
        </div>
        <div className="absolute top-4 right-4">
          <span className="px-3 py-1 bg-primary text-primary-foreground text-xs font-semibold rounded-full">
            {project?.category}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-6">
        <h3 className="text-lg md:text-xl font-semibold mb-2 line-clamp-1">
          {project?.title}
        </h3>
        <p className="text-sm md:text-base text-muted-foreground mb-4 line-clamp-2">
          {project?.description}
        </p>

        <div className="flex flex-wrap gap-2 mb-4">
          {project?.technologies?.slice(0, 3)?.map((tech, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-muted text-xs rounded-md text-foreground"
            >
              {tech}
            </span>
          ))}
          {project?.technologies?.length > 3 && (
            <span className="px-2 py-1 bg-muted text-xs rounded-md text-muted-foreground">
              +{project?.technologies?.length - 3}
            </span>
          )}
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-border">
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Icon name="Calendar" size={16} color="currentColor" />
            <span>{project?.year}</span>
          </div>
          <div className="flex items-center gap-2 text-sm text-success">
            <Icon name="CheckCircle2" size={16} color="var(--color-success)" />
            <span>Completed</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ProjectCard;